<div class="navblock">
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{ 'Find by name' | translate }}" />
  </div>
  <app-group-filter #groupFilter [isEditable]="false"></app-group-filter>
  <div></div>
  <div class="inputgroup">
    <input type="text" class="dtpickerupleft" value="" />
  </div>
  <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
</div>
<div class="tablewrap resizetable">
  <div class="table">
    <div class="blockheader">{{'Loading'|translate }}</div>
    <table fixedcols="[]" id="driversratingtable" class="hidden">
      <tr>
        <th class="object_column">{{'Driver'|translate}}</th>
        <th>{{'Internal ID'|translate}}</th>
        <th>{{'Rating'|translate}}</th>
        <th class="time_column">{{'Working time'|translate}}</th>
        <th class="mileage_column">{{'Mileage'|translate}}</th>
        <th class="speed_column">{{'Max speed'|translate}}</th>
        <th>{{'Fuel consumption'|translate}}</th>
        <th>{{'Violations'|translate}}</th>
        <th class="time_column">{{'Violations duration'|translate}}</th>
        <th>{{'Penalty'|translate}}</th>
        <th>{{'Penalty/100km'|translate}}</th>
        <th>{{'Penalty/1h'|translate}}</th>
        <th></th>
      </tr>
    </table>
  </div>
</div>
<div class="tablenav">
  <app-pagination [viewmode]="'print reports excel'" [printElementID]="'driversratingtable'"></app-pagination>
</div>

<template #mgmtDialog>
</template>
